<template>
    <v-container fluid>
        <v-card>
            <v-list-item three-line>
                <v-list-item-content>
                    <v-list-item-title class="headline mb-1"><v-icon size="40">mdi-calendar-star</v-icon> QUẢN LÝ NGÀY
                        LỄ</v-list-item-title>
                    <v-list-item-subtitle>Danh sách ngày nghỉ lễ được hưởng lương trong năm</v-list-item-subtitle>
                </v-list-item-content>
                <v-btn color="secondary" @click="showFormAdd">
                    <v-icon color="white">mdi-plus</v-icon>
                    <span style="color: white" class="btn-add">Thêm ngày lễ</span>
                </v-btn>
            </v-list-item>
        </v-card>
        <br />
        <v-card class="mb-4">
            <v-row class="px-4 pt-4 pb-4" align="center">
                <v-col cols="12" sm="4" md="3">
                    <div class="label-form">Năm</div>
                    <v-select v-model="nam" :items="namOptions" outlined dense hide-details="auto"
                        prepend-inner-icon="mdi-calendar" @change="changeNam"></v-select>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" sm="4" md="3" class="text-sm-right">
                    <v-chip color="primary px-6 outlined">
                        <v-icon left size="16">mdi-calendar-multiple</v-icon>
                        {{ tableData.length }} ngày lễ năm {{ nam }}
                    </v-chip>
                </v-col>
            </v-row>
        </v-card>

        <v-row v-if="loading">
            <v-col v-for="n in 8" :key="'skeleton-' + n" cols="12" sm="6" md="4" lg="3">
                <v-skeleton-loader type="article" class="elevation-2 rounded-lg"></v-skeleton-loader>
            </v-col>
        </v-row>

        <div v-else-if="tableData.length === 0" class="empty-state text-center py-12">
            <v-icon size="96" color="grey lighten-1">mdi-calendar-remove</v-icon>
            <div class="text-h6 grey--text text--darken-1 mt-4">
                Chưa có ngày lễ nào trong năm {{ nam }}
            </div>
            <v-btn color="primary" class="mt-4" outlined @click="showFormAdd">
                <v-icon left>mdi-plus</v-icon>
                Thêm ngày lễ
            </v-btn>
        </div>

        <v-row v-else>
            <v-col v-for="item in tableData" :key="item.id" cols="12" sm="6" md="4" lg="3">
                <v-card class="ngayle-card rounded-lg" elevation="2" outlined>
                    <div class="ngayle-card__top" :style="{ background: cardColor(item.ngay_le) }">
                        <div class="ngayle-card__date">
                            <div class="ngayle-card__day">{{ dayOf(item.ngay_le) }}</div>
                            <div class="ngayle-card__month">Th {{ monthOf(item.ngay_le) }}</div>
                        </div>
                        <div class="ngayle-card__weekday">{{ weekdayOf(item.ngay_le) }}</div>
                        <v-menu bottom left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon small v-bind="attrs" v-on="on" class="ngayle-card__menu">
                                    <v-icon color="white">mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item @click="showFormEdit(item)">
                                    <v-list-item-icon class="mr-2">
                                        <v-icon small>mdi-pencil</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>Chỉnh sửa</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="deleteNgayLe(item)">
                                    <v-list-item-icon class="mr-2">
                                        <v-icon small color="error">mdi-delete</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>Xóa ngày lễ</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                    <v-card-text class="ngayle-card__body">
                        <div class="ngayle-card__title" :title="item.ten_ngay_le">
                            {{ item.ten_ngay_le || "(Chưa đặt tên)" }}
                        </div>
                        <v-chip :color="statusInfo(item.ngay_le).color" small label dark class="mt-2">
                            <v-icon left small>{{ statusInfo(item.ngay_le).icon }}</v-icon>
                            {{ statusInfo(item.ngay_le).text }}
                        </v-chip>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="showForm" persistent width="500">
            <v-card>
                <v-card-title class="headline">{{
                    edit ? "CẬP NHẬT NGÀY LỄ" : "THÊM NGÀY LỄ"
                    }}</v-card-title>
                <br />
                <v-form ref="form" lazy-validation>
                    <v-card-text>
                        <div class="label-form">Tên ngày lễ</div>
                        <v-text-field placeholder="Nhập tên ngày lễ" outlined dense v-model="form.ten_ngay_le"
                            prepend-inner-icon="mdi-calendar-star" :rules="tenNgayLeRules"></v-text-field>
                        <div class="label-form">Ngày lễ</div>
                        <v-text-field placeholder="Chọn ngày lễ" outlined type="date" dense v-model="form.ngay_le"
                            prepend-inner-icon="mdi-calendar" :rules="ngayLeRules"></v-text-field>
                        <div class="label-form">Mô tả</div>
                        <v-textarea placeholder="Mô tả về ngày lễ" rows="2" outlined dense v-model="form.mo_ta"
                            prepend-inner-icon="mdi-note"></v-textarea>
                    </v-card-text>
                </v-form>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="showForm = false" class="mr-4">Đóng</v-btn>
                    <v-btn :loading="btnLoading" color="primary" v-if="edit" @click="update">
                        <v-icon left>mdi-pencil</v-icon>
                        Cập nhật
                    </v-btn>
                    <v-btn :loading="btnLoading" color="primary" v-else @click="submit">
                        <v-icon left>mdi-plus</v-icon>
                        Thêm mới
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { getNgayLe, addNgayLe, editNgayLe, xoaNgayLe } from "@/api/ngayle";

const WEEKDAYS = [
    "Chủ nhật",
    "Thứ hai",
    "Thứ ba",
    "Thứ tư",
    "Thứ năm",
    "Thứ sáu",
    "Thứ bảy",
];

export default {
    data() {
        const currentYear = new Date().getFullYear();
        return {
            edit: false,
            loading: false,
            btnLoading: false,
            showForm: false,
            nam: currentYear,
            namOptions: Array.from({ length: 11 }, (_, i) => currentYear - 5 + i),
            form: {
                ten_ngay_le: null,
                mo_ta: null,
                ngay_le: null,
            },
            tableData: [],
            tenNgayLeRules: [(v) => !!v || "Tên ngày lễ không thể bỏ trống"],
            ngayLeRules: [(v) => !!v || "Ngày lễ không thể bỏ trống"],
        };
    },
    created() {
        this.getData();
    },
    methods: {
        async getData() {
            try {
                this.loading = true;
                const res = await getNgayLe({
                    nam: this.nam,
                });
                this.tableData = res.data || [];
            } finally {
                this.loading = false;
            }
        },
        dayOf(e) {
            if (!e) return "";
            const d = new Date(e).getDate();
            return d < 10 ? "0" + d : d;
        },
        monthOf(e) {
            if (!e) return "";
            const m = new Date(e).getMonth() + 1;
            return m < 10 ? "0" + m : m;
        },
        weekdayOf(e) {
            if (!e) return "";
            return WEEKDAYS[new Date(e).getDay()];
        },
        formatDate(e) {
            if (!e) return "";
            try {
                let date = new Date(e);
                let ngay = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
                let thang =
                    Number(date.getMonth() + 1) < 10
                        ? "0" + Number(date.getMonth() + 1)
                        : Number(date.getMonth() + 1);
                return ngay + "/" + thang + "/" + date.getFullYear();
            } catch (error) {
                return "";
            }
        },
        // So sánh theo ngày (bỏ qua giờ) để xác định trạng thái
        compareToToday(e) {
            const target = new Date(e);
            target.setHours(0, 0, 0, 0);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return target.getTime() - today.getTime();
        },
        statusInfo(e) {
            const diff = this.compareToToday(e);
            if (diff > 0) {
                return { text: "Sắp tới", color: "primary", icon: "mdi-clock-outline" };
            }
            if (diff === 0) {
                return { text: "Hôm nay", color: "success", icon: "mdi-star" };
            }
            return { text: "Đã qua", color: "pink lighten-3", icon: "mdi-check" };
        },
        cardColor(e) {
            const diff = this.compareToToday(e);
            if (diff > 0) {
                return "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)";
            }
            if (diff === 0) {
                return "linear-gradient(135deg, #2e7d32 0%, #66bb6a 100%)";
            }
            return "linear-gradient(135deg, #f06292 0%, #f8bbd0 100%)";
        },
        changeNam() {
            this.getData();
        },
        showFormAdd() {
            this.edit = false;
            this.showForm = true;
            this.resetForm();
        },
        showFormEdit(data) {
            this.edit = true;
            this.showForm = true;
            this.form = {
                id: data.id,
                ten_ngay_le: data.ten_ngay_le,
                mo_ta: data.mo_ta,
                ngay_le: data.ngay_le ? data.ngay_le.substring(0, 10) : null,
            };
        },
        resetForm() {
            this.form = {
                ten_ngay_le: null,
                mo_ta: null,
                ngay_le: null,
            };
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        },
        async submit() {
            if (this.$refs.form.validate()) {
                this.btnLoading = true;
                try {
                    await addNgayLe({ ...this.form });
                    this.showForm = false;
                    this.resetForm();
                    this.getData();
                    this.notify(true, "Thêm ngày lễ");
                } catch (error) {
                    this.notify(false, "Thêm ngày lễ");
                } finally {
                    this.btnLoading = false;
                }
            }
        },
        async update() {
            if (this.$refs.form.validate()) {
                this.btnLoading = true;
                try {
                    await editNgayLe({ ...this.form });
                    this.showForm = false;
                    this.resetForm();
                    this.getData();
                    this.notify(true, "Cập nhật ngày lễ");
                } catch (error) {
                    this.notify(false, "Cập nhật ngày lễ");
                } finally {
                    this.btnLoading = false;
                }
            }
        },
        async deleteNgayLe(data) {
            this.$confirmBox.show({
                title: "Xóa ngày lễ",
                width: 500,
                body:
                    "Bạn có chắc chắn muốn xóa ngày lễ " +
                    "<strong>" +
                    (data.ten_ngay_le || "") +
                    "</strong> (" +
                    this.formatDate(data.ngay_le) +
                    ")",
                action: () => xoaNgayLe({ id: data.id }),
                onDone: this.getData,
            });
        },
        notify(isSuccess = true, mess) {
            let params = {
                position: "top-center",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: "button",
                icon: true,
            };
            if (isSuccess) {
                this.$toast.info(`${mess} thành công`, {
                    timeout: 2000,
                    ...params,
                });
            } else {
                this.$toast.error(`${mess} thất bại`, {
                    timeout: 6000,
                    ...params,
                });
            }
        },
    },
};
</script>

<style scoped>
.ngayle-card {
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    overflow: hidden;
    height: 100%;
}

.ngayle-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
}

.ngayle-card__top {
    position: relative;
    display: flex;
    align-items: center;
    padding: 16px;
    color: #fff;
}

.ngayle-card__date {
    text-align: center;
    line-height: 1;
    min-width: 56px;
}

.ngayle-card__day {
    font-size: 32px;
    font-weight: 700;
}

.ngayle-card__month {
    font-size: 13px;
    text-transform: uppercase;
    opacity: 0.9;
    margin-top: 2px;
}

.ngayle-card__weekday {
    margin-left: 14px;
    font-size: 16px;
    font-weight: 500;
}

.ngayle-card__menu {
    position: absolute;
    top: 6px;
    right: 6px;
}

.ngayle-card__body {
    padding: 16px;
}

.ngayle-card__title {
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.87);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.empty-state {
    background: #fafafa;
    border-radius: 12px;
}

@media only screen and (max-width: 600px) {
    .btn-add {
        display: none;
    }
}
</style>
